var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-container"},[_c('v-select',{attrs:{"value":_vm.value,"id":_vm.inputId,"options":_vm.options,"searchable":false,"clearable":false,"components":{OpenIndicator: _vm.OpenIndicator}},on:{"input":_vm.processInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SelectInput.vue?vue&type=template&id=6bfe22a4&
// module id = 757
// module chunks = 2